import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import sc from '../../classes.scss'
import {LinkToPage} from '../../link-to-page'
import {TitleProps} from './interfaces'
import s from './title.scss'

export const Title = ({event, onImage}: TitleProps) => (
  <div
    className={classNames(s.root, sc.textNoMargin, sc.preWrap, {
      [s.onImage]: onImage,
    })}
    data-hook={DH.eventTitle}
  >
    <LinkToPage event={event} allowExternal>
      {event.title}
    </LinkToPage>
  </div>
)
